<script setup lang="ts">
import { resolveComponent } from 'vue'
import type { CmsBlockGalleryBuybox } from '@shopware/composables'

const props = defineProps<{
    content: CmsBlockGalleryBuybox
}>()

const { getCmsSlot, getCmsElementName } = useCms()
const gallerySlot = computed(() => getCmsSlot(props.content, 'gallery'))
const buyboxSlot = computed(() => getCmsSlot(props.content, 'buybox'))
const descriptionSlot = computed(() => getCmsSlot(props.content, 'description'))
</script>

<template>
    <div class="grid grid-cols-1 gap-4 md:gap-8 md:grid-cols-3 md:grid-rows-[auto_1fr]">
        <!-- Gallery - Desktop: top-left (2 cols), Mobile: first -->
        <div class="order-1 md:col-span-2 md:row-start-1">
            <component
                :is="resolveComponent(getCmsElementName(gallerySlot?.type))"
                v-if="gallerySlot"
                :content="gallerySlot"
            />
        </div>

        <!-- Buybox - Desktop: right column (spans both rows), Mobile: second -->
        <div class="order-2 md:col-span-1 md:row-span-2 md:row-start-1">
            <component
                :is="resolveComponent(getCmsElementName(buyboxSlot?.type))"
                v-if="buyboxSlot"
                :content="buyboxSlot.data"
            />
        </div>

        <!-- Description - Desktop: bottom-left (2 cols), Mobile: third -->
        <div class="order-3 md:col-span-2 md:row-start-2">
            <component
                :is="resolveComponent(getCmsElementName(descriptionSlot?.type))"
                v-if="descriptionSlot"
                :content="descriptionSlot.data"
            />
        </div>
    </div>
</template>

